var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.25 18.25H16.75",
    stroke: "#C20B0B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 22.75V28.75",
    stroke: "#C20B0B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.25 22.75V28.75",
    stroke: "#C20B0B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.75 18.25V32.5C31.75 32.6989 31.671 32.8897 31.5303 33.0303C31.3897 33.171 31.1989 33.25 31 33.25H19C18.8011 33.25 18.6103 33.171 18.4697 33.0303C18.329 32.8897 18.25 32.6989 18.25 32.5V18.25",
    stroke: "#C20B0B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 18.25V16.75C28.75 16.3522 28.592 15.9706 28.3107 15.6893C28.0294 15.408 27.6478 15.25 27.25 15.25H22.75C22.3522 15.25 21.9706 15.408 21.6893 15.6893C21.408 15.9706 21.25 16.3522 21.25 16.75V18.25",
    stroke: "#C20B0B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRound);
export default __webpack_public_path__ + "static/media/deleteRound.35f426910813dadc49e4ee3c003fd64c.svg";
export { ForwardRef as ReactComponent };